import React from "react";
import { useTranslation } from "react-i18next";
import { EmptyState } from "../../../components/m3";

// Placeholder for a Scope & Boundary indicator whose data tracking is not available yet.
const IndicatorPlaceholderPanel = ({ icon: Icon, title, description }) => {
  const { t } = useTranslation();
  return <EmptyState plain icon={Icon ? <Icon size={26} /> : null} title={t(title)} description={t(description)} />;
};

export default IndicatorPlaceholderPanel;
